import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=6df3640d&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=6df3640d&prod&scoped=true&lang=css"
import style1 from "./Menu.vue?vue&type=style&index=1&id=6df3640d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3640d",
  null
  
)

export default component.exports